import { MdAirlineSeatIndividualSuite } from "react-icons/md";
import suiteCategory from "./suiteCategory";
import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "deckSuiteCategory",
  title: "Deck Suite Category",
  type: "document",
  icon: MdAirlineSeatIndividualSuite,
  preview: {
    select: {
      suiteCategory: "suiteCategory.name"
    },
    prepare({ suiteCategory }) {
      return {
        title: multilingualStringPreview(suiteCategory)
      };
    }
  },
  fields: [
    {
      name: "suiteCategory",
      title: "Suite Category",
      type: "reference",
      to: [{ type: suiteCategory.name }]
    }
  ]
});
